import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_FETCH } from '../../services';
import { ENDPOINTS } from '../../constants/endpoints';

export interface WorkerEligibility {
    lookupValueCd: string, 
    lookupValueDesc: string
}

interface eligibilityState {
    eligibility: WorkerEligibility[] | null;
    loading: boolean;
    error: string | null;
}

const initialState: eligibilityState = {
    eligibility: [],
    loading: false,
    error: null,
};


// ========================================
// ASYNC THUNKS
// ========================================
/**
 * Fetch eligibility by passing the site code as a query parameter
 * Uses: ENDPOINTS.GET_ELIGIBILITY + siteID
 */
export const fetchEligibility = createAsyncThunk(
    'Eligibility/fetchEligibility',
    async (siteCd: string, { rejectWithValue }) => {
        try {
            const response = await API_FETCH(`${ENDPOINTS.GET_ELIGIBILITY}/${siteCd}`);
            return response;
        } catch (error: any) {
            return rejectWithValue(error?.message || 'Failed to fetch eligibility');
        }
    }
);


// ========================================
// SLICE
// ========================================
const eligibilitySlice = createSlice({
    name: 'eligibility',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEligibility.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchEligibility.fulfilled, (state, action) => {
                state.loading = false;
                state.eligibility = action.payload;
            })
            .addCase(fetchEligibility.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearError } = eligibilitySlice.actions;
export default eligibilitySlice.reducer;